import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

import { 
    IonContent, IonList, IonItem, IonIcon, IonLabel, IonHeader, IonToolbar, 
    IonButtons, IonButton, IonTitle, IonAvatar, IonMenu, IonMenuButton,
    NavController, AlertController, MenuController 
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { DemoozNavigationService } from '@demooz/services';
import { DataService, LanguagesService } from '@app/services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        IonContent, IonList, IonItem, IonIcon, IonLabel, IonHeader, IonToolbar, 
        IonButtons, IonButton, IonTitle, IonAvatar, IonMenu, IonMenuButton, TranslatePipe
    ]
})
export class HeaderComponent  implements OnInit {
    
    currentRoute: string = '';
    
    constructor(
        private router: Router,
        public translateService: TranslateService,
        private navController: NavController,
        private alertController: AlertController,
        private menuCtrl: MenuController,
        public demoozNavigationService: DemoozNavigationService,
        public languagesService: LanguagesService,
        public dataService: DataService
    ) {
    
        router.events.subscribe((event) => {
            if(event instanceof NavigationStart ){
                this.currentRoute = event.url.substr(1);                
            }            
        });    
        
    }

    ngOnInit() {
       
    }
    
    openMenu() {
        this.menuCtrl.open('main_menu');
    }    
    
    closeMenu(){
        this.menuCtrl.close('main_menu');
    }
    
    goBack() {
        this.closeMenu();
        this.demoozNavigationService.back();
    }
    
    goTo(route: string, replaceUrl: boolean = false) {
        this.closeMenu();
        this.navController.navigateRoot(route, {replaceUrl: replaceUrl});
    }
    
    async logout(){
        const alert = await this.alertController.create({
            message: this.translateService.instant('HEADER.MSG_CONFIRM_LOGOUT'),
            buttons: [{
                    text: this.translateService.instant('MAIN.CANCEL'),
                    role: 'cancel'
                },
                {
                    text: this.translateService.instant('MAIN.VALIDATE'),
                    role: 'confirm',
                    handler: () => {                        
                        this.goTo('logout', true)              
                    }
                }                    
            ],
        })
        await alert.present();    
        
    }
}
